(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["get-featured-hob-new"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        const modelImages = document.querySelectorAll('.ai-matchmaker__left .hob-life-blockcs-custom-bhoopi-blocks');
        const sliderTrack = document.querySelector('.ai-slider-track');
        const slides = document.querySelectorAll('.ai-slide');
        const prevBtn = document.querySelector('[data-prev]');
        const nextBtn = document.querySelector('[data-next]');
        const sliderWrapper = document.querySelector('.ai-slider-wrapper');
        
        if (!slides.length || !modelImages.length) return;
        
        let currentIndex = 0;
        const totalSlides = slides.length;
        
        // Drag/Touch variables
        let isDragging = false;
        let startPos = 0;
        let startPosY = 0; // Track vertical position
        let currentTranslate = 0;
        let prevTranslate = 0;
        let animationId = 0;
        let dragDirection = null; // Track if user is dragging horizontally or vertically
        
        // Calculate slides per view based on actual slide width
        function getSlidesPerView() {
            if (!slides[0]) return 1;
            const containerWidth = sliderTrack.parentElement.offsetWidth - 100;
            const slideWidth = slides[0].offsetWidth + 20;
            const calculated = Math.floor(containerWidth / slideWidth);
            return Math.max(1, Math.min(calculated, totalSlides));
        }
        
        function updateSlider() {
            const slideWidth = slides[0].offsetWidth + 20;
            const translateX = -(currentIndex * slideWidth);
            sliderTrack.style.transform = `translateX(${translateX}px)`;
            
            // Update model image
            modelImages.forEach((img, index) => {
                img.style.display = index === currentIndex ? 'block' : 'none';
            });
            
            // Update button states
            const slidesPerView = getSlidesPerView();
            prevBtn.disabled = currentIndex <= 0;
            const maxIndex = Math.max(0, totalSlides - slidesPerView);
            nextBtn.disabled = currentIndex >= maxIndex;
        }
        
        function nextSlide() {
            const slidesPerView = getSlidesPerView();
            const maxIndex = Math.max(0, totalSlides - slidesPerView);
            if (currentIndex < maxIndex) {
                currentIndex++;
                updateSlider();
            }
        }
        
        function prevSlide() {
            if (currentIndex > 0) {
                currentIndex--;
                updateSlider();
            }
        }
        
        // Drag/Touch Functions
        function setSliderPosition() {
            sliderTrack.style.transform = `translateX(${currentTranslate}px)`;
        }
        
        function animation() {
            setSliderPosition();
            if (isDragging) requestAnimationFrame(animation);
        }
        
        function setPositionByIndex() {
            const slideWidth = slides[0].offsetWidth + 20;
            currentTranslate = -currentIndex * slideWidth;
            prevTranslate = currentTranslate;
            setSliderPosition();
        }
        
        // Mouse Events
        function dragStart(e) {
            // Don't start dragging on images or clickable elements
            if (e.target.tagName === 'IMG' || e.target.closest('a, button')) {
                return;
            }
            
            isDragging = true;
            dragDirection = null; // Reset direction
            
            if (e.type.includes('mouse')) {
                startPos = e.clientX;
                startPosY = e.clientY;
            } else {
                startPos = e.touches[0].clientX;
                startPosY = e.touches[0].clientY;
            }
            
            animationId = requestAnimationFrame(animation);
            sliderTrack.style.transition = 'none';
            sliderTrack.style.cursor = 'grabbing';
        }
        
        function dragMove(e) {
            if (!isDragging) return;
            
            const currentPosition = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            const currentPositionY = e.type.includes('mouse') ? e.clientY : e.touches[0].clientY;
            
            const diffX = currentPosition - startPos;
            const diffY = currentPositionY - startPosY;
            
            // Determine drag direction on first move (with bigger threshold for horizontal)
            if (dragDirection === null && (Math.abs(diffX) > 5 || Math.abs(diffY) > 5)) {
                if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
                    dragDirection = 'horizontal';
                } else {
                    dragDirection = 'vertical';
                }
            }
            
            // Only prevent default and handle drag if it's clearly horizontal
            if (dragDirection === 'horizontal') {
                e.preventDefault();
                currentTranslate = prevTranslate + diffX;
            } else if (dragDirection === 'vertical') {
                // If vertical drag, stop slider dragging to allow page scroll
                isDragging = false;
                cancelAnimationFrame(animationId);
                sliderTrack.style.cursor = 'grab';
                sliderTrack.style.transition = 'transform 0.3s ease';
                setPositionByIndex();
                return;
            }
        }
        
        function dragEnd(e) {
            if (!isDragging) return;
            isDragging = false;
            cancelAnimationFrame(animationId);
            
            sliderTrack.style.transition = 'transform 0.3s ease';
            sliderTrack.style.cursor = 'grab';
            
            const slideWidth = slides[0].offsetWidth + 20;
            const movedBy = currentTranslate - prevTranslate;
            
            // Determine if we should slide next or previous
            if (movedBy < -100 && currentIndex < totalSlides - getSlidesPerView()) {
                currentIndex++;
            } else if (movedBy > 100 && currentIndex > 0) {
                currentIndex--;
            }
            
            setPositionByIndex();
            updateSlider();
        }
        
        // Add styles for drag cursor - only on non-image areas
        sliderTrack.style.userSelect = 'none';
        
        // Mouse Events - only attach to slider track, not images
        sliderTrack.addEventListener('mousedown', function(e) {
            // Only start drag if not clicking on image or clickable elements
            if (!e.target.tagName === 'IMG' && !e.target.closest('a, button')) {
                dragStart(e);
            }
        });
        sliderTrack.addEventListener('mousemove', dragMove);
        sliderTrack.addEventListener('mouseup', dragEnd);
        sliderTrack.addEventListener('mouseleave', dragEnd);
        
        // Touch Events - with better handling
        sliderTrack.addEventListener('touchstart', function(e) {
            // Only start drag if not touching image or clickable elements  
            if (!e.target.tagName === 'IMG' && !e.target.closest('a, button')) {
                dragStart(e);
            }
        }, { passive: true });
        sliderTrack.addEventListener('touchmove', dragMove, { passive: false });
        sliderTrack.addEventListener('touchend', dragEnd);
        
        // Alternative approach: Add scroll wheel support back for images
        sliderTrack.addEventListener('wheel', function(e) {
            // If scrolling over an image, allow normal page scroll
            if (e.target.tagName === 'IMG') {
                return; // Don't prevent default, allow page scroll
            }
        }, { passive: true });
        
        // Arrow Events
        nextBtn.addEventListener('click', nextSlide);
        prevBtn.addEventListener('click', prevSlide);
        
        // Keyboard Events
        document.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                prevSlide();
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                nextSlide();
            }
        });
        
        // Window Resize
        window.addEventListener('resize', function() {
            currentIndex = 0;
            updateSlider();
            setPositionByIndex();
        });
        
        // Initialize
        updateSlider();
        setPositionByIndex();
        
    }, 200);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home_img_Slider_horiz"] && !Shopify.designMode) return;
  try {
    

window.handleNavigate = function(url) {
  try {
    if (!url) return;
    window.location.assign(String(url));
  } catch (err) {
    console.error('handleNavigate error', err);
  }
};   


document.addEventListener('DOMContentLoaded', function() {
  
  const swiper = new Swiper('#verticalSwiper', {
    direction: 'horizontal',
    loop: true,
    speed: 800,
    autoplay:{
     delay:3000
    },
    // mousewheel: {
    //   enabled: true,
    //   releaseOnEdges: true,
      
    // },
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    touchRatio: 1,
    threshold: 10,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-bottom-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        const modelImages = document.querySelectorAll('.ai-matchmaker__left img');
        const sliderTrack = document.querySelector('.ai-slider-track');
        const slides = document.querySelectorAll('.ai-slide');
        const prevBtn = document.querySelector('[data-prev]');
        const nextBtn = document.querySelector('[data-next]');
        const sliderWrapper = document.querySelector('.ai-slider-wrapper');
        
        if (!slides.length || !modelImages.length) return;
        
        let currentIndex = 0;
        const totalSlides = slides.length;
        
        // Drag/Touch variables
        let isDragging = false;
        let startPos = 0;
        let currentTranslate = 0;
        let prevTranslate = 0;
        let animationId = 0;
        
        // Calculate slides per view based on actual slide width
        function getSlidesPerView() {
            if (!slides[0]) return 1;
            const containerWidth = sliderTrack.parentElement.offsetWidth - 100;
            const slideWidth = slides[0].offsetWidth + 20;
            const calculated = Math.floor(containerWidth / slideWidth);
            return Math.max(1, Math.min(calculated, totalSlides));
        }
        
        function updateSlider() {
            const slideWidth = slides[0].offsetWidth + 20;
            const translateX = -(currentIndex * slideWidth);
            sliderTrack.style.transform = `translateX(${translateX}px)`;
            
            // Update model image
            modelImages.forEach((img, index) => {
                img.style.display = index === currentIndex ? 'block' : 'none';
            });
            
            // Update button states
            const slidesPerView = getSlidesPerView();
            prevBtn.disabled = currentIndex <= 0;
            const maxIndex = Math.max(0, totalSlides - slidesPerView);
            nextBtn.disabled = currentIndex >= maxIndex;
        }
        
        function nextSlide() {
            const slidesPerView = getSlidesPerView();
            const maxIndex = Math.max(0, totalSlides - slidesPerView);
            if (currentIndex < maxIndex) {
                currentIndex++;
                updateSlider();
            }
        }
        
        function prevSlide() {
            if (currentIndex > 0) {
                currentIndex--;
                updateSlider();
            }
        }
        
        // Drag/Touch Functions
        function setSliderPosition() {
            sliderTrack.style.transform = `translateX(${currentTranslate}px)`;
        }
        
        function animation() {
            setSliderPosition();
            if (isDragging) requestAnimationFrame(animation);
        }
        
        function setPositionByIndex() {
            const slideWidth = slides[0].offsetWidth + 20;
            currentTranslate = -currentIndex * slideWidth;
            prevTranslate = currentTranslate;
            setSliderPosition();
        }
        
        // Mouse Events
        function dragStart(e) {
            e.preventDefault();
            isDragging = true;
            startPos = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            animationId = requestAnimationFrame(animation);
            sliderTrack.style.transition = 'none';
            sliderTrack.style.cursor = 'grabbing';
        }
        
        function dragMove(e) {
            if (!isDragging) return;
            e.preventDefault();
            
            const currentPosition = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            const diff = currentPosition - startPos;
            currentTranslate = prevTranslate + diff;
        }
        
        function dragEnd() {
            if (!isDragging) return;
            isDragging = false;
            cancelAnimationFrame(animationId);
            
            sliderTrack.style.transition = 'transform 0.3s ease';
            
            
            const slideWidth = slides[0].offsetWidth + 20;
            const movedBy = currentTranslate - prevTranslate;
            
            // Determine if we should slide next or previous
            if (movedBy < -100 && currentIndex < totalSlides - getSlidesPerView()) {
                currentIndex++;
            } else if (movedBy > 100 && currentIndex > 0) {
                currentIndex--;
            }
            
            setPositionByIndex();
            updateSlider();
        }
        
        // Removed wheel/scroll functionality as requested
        
        // Add styles for drag cursor
       
        sliderTrack.style.userSelect = 'none';
        
        // Mouse Events
        sliderTrack.addEventListener('mousedown', dragStart);
        sliderTrack.addEventListener('mousemove', dragMove);
        sliderTrack.addEventListener('mouseup', dragEnd);
        sliderTrack.addEventListener('mouseleave', dragEnd);
        
        // Touch Events
        sliderTrack.addEventListener('touchstart', dragStart, { passive: false });
        sliderTrack.addEventListener('touchmove', dragMove, { passive: false });
        sliderTrack.addEventListener('touchend', dragEnd);
        
        // Arrow Events
        nextBtn.addEventListener('click', nextSlide);
        prevBtn.addEventListener('click', prevSlide);
        
        // Keyboard Events
        document.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                prevSlide();
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                nextSlide();
            }
        });
        
        // Window Resize
        window.addEventListener('resize', function() {
            currentIndex = 0;
            updateSlider();
            setPositionByIndex();
        });
        
        // Initialize
        updateSlider();
        setPositionByIndex();
        
    }, 200);
});

  } catch(e) { console.error(e); }
})();
})();
